import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { StickyBanner } from "@/components/StickyBanner";
import { SEO } from "@/components/SEO";
import { SpanishHero } from "@/components/SpanishHero";
import { SpanishWhyUs } from "@/components/SpanishWhyUs";
import { SpanishServices } from "@/components/SpanishServices";
import { SpanishTestimonials } from "@/components/SpanishTestimonials";
import { SpanishFAQ } from "@/components/SpanishFAQ";
import { SpanishFinalCTA } from "@/components/SpanishFinalCTA";
import { SpanishReferFriend } from "@/components/SpanishReferFriend";
import { LocationContext } from "@/lib/locations";

import { Guarantee } from "@/components/Guarantee";
import { PricingCalculator } from "@/components/PricingCalculator";
import { FrequencyDiscounts } from "@/components/FrequencyDiscounts";

const SacramentoSpanishPage = () => {
  return (
    <LocationContext.Provider value={{ slug: "sacramento-area", name: "Sacramento", type: "region", regionSlug: "sacramento-area" }}>
      <SEO
        title="Limpieza del Hogar en Sacramento — Uplevel Cleaning"
        description="Servicio profesional de limpieza del hogar en Sacramento, Roseville, Elk Grove y más. Precios planos y transparentes, reserva en 60 segundos, garantía de satisfacción del 200%."
        keywords="limpieza del hogar sacramento, servicio de limpieza sacramento, limpieza profunda sacramento, limpieza de mudanza sacramento, empleada doméstica sacramento, limpieza de casas sacramento ca"
        url="https://uplevelcleaning.com/es/sacramento"
        alternateUrl="https://uplevelcleaning.com/"
        alternateLang="en-US"
        locationName="Sacramento"
        regionSlug="sacramento-area"
        lang="es"
        includeLocalBusiness={true}
        includeFAQ={true}
        breadcrumbs={[
          { name: "Inicio", url: "/" },
          { name: "En Español", url: "/es" },
          { name: "Sacramento", url: "/es/sacramento" }
        ]}
        reviews={[
          { author: "María G.", rating: 5, reviewBody: "¡Excelente servicio! El equipo llegó a tiempo y dejó mi casa perfectamente limpia. Los recomiendo al 100%.", datePublished: "2026-03-10" },
          { author: "José R.", rating: 5, reviewBody: "La limpieza profunda superó todas mis expectativas. Muy profesionales y detallistas.", datePublished: "2026-02-20" },
          { author: "Ana L.", rating: 5, reviewBody: "Con dos niños en casa, necesito un equipo de confianza. Uplevel Cleaning es increíble.", datePublished: "2026-01-15" }
        ]}
      />
      <div className="flex min-h-screen flex-col" lang="es">
        <StickyBanner />
        <Navbar />
        <main className="flex-1">
          <SpanishHero cityName="Sacramento" regionSlug="sacramento-area" />
          <SpanishWhyUs cityName="Sacramento" />
          <SpanishServices />

          <FrequencyDiscounts />
          <PricingCalculator />
          <SpanishTestimonials region="sacramento" />
          <Guarantee />
          <SpanishReferFriend />
          <SpanishFAQ cityName="Sacramento" />
          <SpanishFinalCTA cityName="Sacramento" />
        </main>
        <Footer />
      </div>
    </LocationContext.Provider>
  );
};

export default SacramentoSpanishPage;
